import { Tooltip } from 'antd';
import React, { useMemo } from 'react';
import { useStores } from '../../store';
import PinPointOrange from '@svg/pin_point_orange.svg?react';
import PinPointRed from '@svg/pin_point_red.svg?react';
import { observer } from 'mobx-react-lite';
import { MAX_ADDRESSES_LIMIT } from '../../../utils/constants';
import './address-limit.scss';

export const AddressLimit = observer(() => {

    const {fwVersionStore} = useStores();

    const ADDRESSES_WARNING_LIMIT = MAX_ADDRESSES_LIMIT - 50; // Warning threshold for addresses

    const addressesCount = useMemo(() => fwVersionStore.selectedFwVersion?.content.policy.addresses.length
        , [fwVersionStore.selectedFwVersion]);

    const addressLimitStatus = useMemo(() => {
        if (!addressesCount) return null;
        if (addressesCount >= MAX_ADDRESSES_LIMIT) {
            return {
                icon: <PinPointRed />,
                tooltip: `You have reached the maximum limit of ${MAX_ADDRESSES_LIMIT} IP addresses. No additional IP addresses can be added.`
            };
        }
        if (addressesCount >= ADDRESSES_WARNING_LIMIT) {
            return {
                icon: <PinPointOrange />,
                tooltip: `Your policy includes ${addressesCount} IP addresses out of the allowed maximum of ${MAX_ADDRESSES_LIMIT}`
            };
        }
        return null;
    }, [addressesCount]);

    return (
        <div className={'address-limit'}>
            {addressLimitStatus && (
                <Tooltip placement={'bottom'} title={addressLimitStatus.tooltip}>
                    {addressLimitStatus.icon}
                </Tooltip>
            )}
        </div>
    );
});